<template>
  <section id="tac-admin-catalog-home-scroller" class="tac-admin-catalog-home-scroller tac-admin-catalog-home-scroller__record">
    <div class="page-header">
      <h1 class="page-header-title">
        <router-link :to="{name: 'admin/catalog-home/scroller/browse'}" class="page-header__title-link--no-highlight">
          <span class="fa fa-fw fa-th"></span> Scroller Editor <span v-if="isNew" class="text-warning">[ * NEW ]</span>
        </router-link>
      </h1>
      <div class="page-header-actions page-header-actions--right-position">
        <div class="form-inline form-inline--better-spaced form-inline--compact form-inline--one-liner">
          <div class="form-group">
            <div class="input-group input-group-sm">
              <input type="text" class="form-control" placeholder="Search for..." v-model="filter" @keypress.enter="search">
              <span class="input-group-btn">
                <button class="btn btn-default" type="button" @click="search" :disabled="isBusy"><i class="fa fa-fw fa-search"></i> <span class="sr-only">Search</span></button>
                <button class="btn btn-default" type="button" @click="clear" :disabled="isBusy"><i class="fa fa-fw fa-times"></i> <span class="sr-only">Clear</span></button>
              </span>
            </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group">
            <div class="btn-toolbar">
              <div class="btn-group btn-group-sm">
                <button type="button" class="btn btn-primary" @click.prevent="save" :disabled="isBusy || isDiscarded" title="Save and Stay">Save</button>
                <button type="button" class="btn btn-primary" @click.prevent="saveAndExit" :disabled="isBusy || isDiscarded" title="Save and Exit">Save &amp; Exit</button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group">
            <div class="btn-toolbar">
              <div class="btn-group btn-group-sm">
                <button type="button" class="btn btn-warning" @click.prevent="handleOnCancel" :disabled="isBusy" title="Cancel Changes and Go Back to Browsing Receipts">Back</button>
                <button type="button" class="btn btn-default" @click="handleOnReload" title="Reload Receipt" :disabled="isBusy"><i class="fa fa-fw fa-refresh"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form class="form">
      <div class="panel panel-default chg-record__general">
        <div class="panel-body">
          <div class="form-inline form-inline-better-spaced form-inline--one-liner">
            <div class="form-group form-group-sm field__chg-number">
              <label>
                <toggle v-model="form.active" :disabled="isBusy" title="Sort #"></toggle> Active
              </label>
            </div>
          </div>
          <div class="form-group form-group-sm field__chg-number">
            <label>Title</label>
            <input type="text" class="form-control" v-model="form.title" :disabled="isBusy" title="Title" style="width: 100rem;" />
          </div>
          <div class="row">
            <div class="col-lg-1">
              <div class="form-group form-group-sm field__chg-number">
                <label>Width</label>
                <input type="text" class="form-control text-center" v-model="form.width" :disabled="isBusy" title="Width" style="width: 5rem;" />
              </div>
            </div>
            <div class="col-lg-1">
              <div class="form-group form-group-sm field__chg-number">
                <label>Height</label>
                <input type="text" class="form-control text-center" v-model="form.height" :disabled="isBusy" title="Height" style="width: 5rem;" />
              </div>
            </div>
            <div class="col-lg-1">
              <div class="form-group form-group-sm field__chg-number">
                <label>Speed</label>
                <input type="text" class="form-control text-center" v-model="form.speed" :disabled="isBusy" title="Transition Speed (in seconds)" style="width: 5rem;" />
              </div>
            </div>
            <div class="col-lg-1">
              <div class="form-group form-group-sm field__chg-number">
                <label>Delay</label>
                <input type="text" class="form-control text-center" v-model="form.delay" :disabled="isBusy" title="Transition Delay (in seconds)" style="width: 5rem;" />
              </div>
            </div>
            <div class="col-lg-1">
              <div class="form-group form-group-sm field__chg-number">
                <label>Feature Width</label>
                <input type="text" class="form-control text-center" v-model="form.featureWidth" :disabled="isBusy" title="Feature Width (in pixels)" style="width: 5rem;" />
              </div>
            </div>
          </div>
          <div class="form-group form-group-sm field__chg-number">
            <label>Position</label>
            <select class="form-control" v-model="form.position" :disabled="isBusy" title="Position" style="width: 15rem;">
              <option value="left">Left</option>
              <option value="right">Right</option>
            </select>
          </div>
          <div class="form-group form-group-sm field__chg-number">
            <label>Sort Number</label>
            <input type="text" class="form-control text-center" v-model="form.sortNumber" :disabled="isBusy" title="Sort #" style="width: 5rem;" />
          </div>
          <div class="form-group form-group-sm field__chg-number">
            <label>Description</label>
            <textarea class="form-control" v-model="form.description" :disabled="isBusy" rows="10"></textarea>
          </div>
        </div><!-- .panel-body -->
      </div><!-- .panel.chg-record__general -->
    </form>
  </section>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex'
import ApiResponseMixin from '@/plugin/mixin/api-response'
import Toggle from '@/plugin/bootstrap/toggle'

export default {
  name: 'browse',
  data() {
    return {
      form: {},
      filter: null,

      fetchingData : false,
      editing : false,
      saving : false,
      isDiscarded : false,
    }
  },
  created() {
    this.init()
  },
  watch: {
    '$route'() {
      this.init()
    },
  },
  computed: {
    ...mapState('catalogHome/scroller/scrollers', {
    }),
    ...mapGetters('catalogHome/scroller/scroller', {
      storeScroller: 'scroller',
      scrollerIsBusy: 'requestingApi',
    }),
    ...mapGetters('catalogHome/scroller/form', {
      scrollerId: 'scrollerId',
      storeForm: 'form',
      formIsBusy: 'requestingApi',
    }),
    isNew() {
      return 'admin/catalog-home/scroller/new' === this.$route.name
    },
    returnLink() {
      return encodeURI(this.$route.fullPath)
    },
    isBusy() {
      return this.formIsBusy || this.scrollerIsBusy
    }
  },
  methods: {
    async init() {
      this.$alertify.dismissAll()

      // set default valuds
      this.resetForm()
      this.initializeForm()

      // load route info
      this.loadByRoute()

      // fetch some options and configurations
      this.fetchOptions()

      // fetch data
      await this.fetchData()

      // clear form, load data and reinitialize form
      this.resetForm()
      await this.loadData()
      this.initializeForm()
    },
    handleOnReload() {
      this.$alertify.dismissAll()
      this.reload()
    },
    handleOnCancel() {
      this.cancel()
    },
    async reload() {
      this.fetchOptions()
      if (!this.isNew) {
        await this.fetchData()
      }
      this.resetForm()
      this.loadData()
      this.initializeForm()
    },
    async loadByRoute() {
      if (this.isNew) {
        this.$store.dispatch('catalogHome/scroller/form/newScroller')
        this.$store.dispatch('catalogHome/scroller/scroller/start')
      } else {
        await this.$store.dispatch('catalogHome/scroller/scroller/view', this.$route.params.scrollerId)
      }
    },
    async fetchOptions() {
      //
    },
    async fetchData() {
      await this.$store.dispatch('catalogHome/scroller/scroller/fetch')
    },
    async loadData() {
      if (this.isNew) {
        this.$store.dispatch('catalogHome/scroller/form/newScroller')
      } else {
        await this.$store.dispatch('catalogHome/scroller/form/loadScroller', this.storeScroller)
      }
    },
    initializeForm() {
      this.myLastLoadTime = new Date().getTime()
      this.form = _.cloneDeep(this.storeForm)
    },
    resetForm() {
      this.$store.dispatch('catalogHome/scroller/form/clear')
    },
    search() {
      let query = Object.assign({}, _.cloneDeep(this.$route.query), {
        query: this.filter
      })

      this.$router.push({
        name   : 'admin/catalog-home/scroller/browse',
        params : _.cloneDeep(this.$route.params),
        query  : query
      })
    },
    clear() {
      this.filter = ''
    },
    async saveAndExit() {
      try {
        await this.save()
        this.cancel()
      } catch (reason) {
        throw reason
      }
    },
    async save() {
      this.$alertify.dismissAll()

      try {
        await this.$store.dispatch('catalogHome/scroller/form/save', this.form)
        this.$alertify.success('Record saved')
      } catch (e) {
        if (this.isResponseError(e)) {
          this.raiseErrorMessage(e)
          return
        } else {
          throw e
        }
      }

      if (this.isNew) {
        this.$router.push({
          name   : 'admin/catalog-home/scroller/record',
          params : Object.assign(_.cloneDeep(this.$route.params), {scrollerId: this.scrollerId}),
          query  : Object.assign(_.cloneDeep(this.$route.query))
        })
      } else {
        this.reload()
      }
    },
    cancel() {
      if (this.isNew && this.$route.query.return) {
        window.location.href = this.$route.query.return
        return
      }

      this.$router.push({
        name   : 'admin/catalog-home/scroller/browse',
        params : _.cloneDeep(this.$route.params),
        query  : _.merge(_.cloneDeep(this.$route.query), {autoOpen: 0})
      })
    },
  },
  components: {
    Toggle
  },
  mixins: [
    ApiResponseMixin
  ]
}
</script>
